import React, { useState } from "react";
import { getInitialsFromEmail } from "../../utils/initials";

interface UserMenuProps {
  email: string;
  onLogout?: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ email, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const initials = getInitialsFromEmail(email);

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      fetch("/api/auth/logout", { method: "POST" }).finally(() => {
        window.location.reload();
      });
    }
  };

  return (
    <div className="relative">
      <button
        className="flex items-center gap-3 focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
        onBlur={() => setTimeout(() => setIsOpen(false), 200)}
      >
        <div className="w-8 h-8 rounded-full bg-gray-800 text-white flex items-center justify-center text-sm font-medium">
          {initials}
        </div>
        <span className="text-sm font-medium text-gray-700 hidden sm:block">
          {email}
        </span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 z-50">
          <div className="py-1">
            <button
              onClick={handleLogout}
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Sign out
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
